module.exports = __webpack_public_path__ + "static/media/user.7d0d9990.png";